import { jsx as _jsx } from "react/jsx-runtime";
import { getXRModule } from './xrModule.js';
import { xrStore } from './xrStore.js';
const { XR } = getXRModule();
export default function XRWrapper({ children }) {
    return (_jsx(XR, { store: xrStore, children: children }));
}
//# sourceMappingURL=XRWrapper.js.map